module.exports = __webpack_public_path__ + "img/journal.1a572f9a.png";